























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getObtainDetailList } from '@/api'
import moment from 'moment'
@Component({
  name: 'GoldenbeanHarvest',
  filters: {
    dateFormat: (value: any, pattern: any) => {
      return moment(value).format(pattern)
    }
  }
})
export default class GoldenbeanHarvest extends Vue {
  [x: string]: any
  list: any = []
  // 当前语言
  @Prop({
    type: String,
    default: 'ug'
  })
  language!: string
  emptyImage = require('@/assets/Empty_NoData.png')

  created() {
    this.getObtainDetailList()
  }

  async getObtainDetailList() {
    const { data, code } = await getObtainDetailList({
      pageNum: 1,
      pageSize: 999
    })
    if (code == 1001) {
      this.list = data.list
      console.log(this.list, '///')
    }
  }
  get num() {
    return (value: any) => {
      if (value.scene == 18) {
        return value.description.substring(
          value.description.lastIndexOf('[') + 1,
          value.description.lastIndexOf(']')
        )
      }
      return ''
    }
  }
  get getScene() {
    return (value: any) => {
      value.num = this.num(value)
      return value.scene == 5
        ? `收获${value.otherUserNickName}赠送的${value.giftName}`
        : value.scene == 4 || value.scene == 8 || value.scene == 14
        ? `回复${value.otherUserNickName}的打招呼消息获得积分`
        : value.scene == 1 || value.scene == 3 || value.scene == 7
        ? `回复${value.otherUserNickName}的消息获得积分`
        : value.scene == 1009 || value.scene == 1021
        ? `签到获得${value.amount}积分`
        : value.scene == 2
        ? `回复${value.otherUserNickName}的平台牵线消息获得积分`
        : value.scene == 1010 || value.scene == 1022
        ? `观看激励视频获得积分`
        : value.scene == 1011 || value.scene == 1023
        ? `发布动态获得积分`
        : value.scene == 1024
        ? `使用今日缘分匹配获得积分`
        : value.scene == 1015
        ? `开通悬浮窗通知获得积分`
        : value.scene == 1016
        ? `开启地理位置获得积分`
        : value.scene == 1005 || value.scene == 1017
        ? `上传5张照片获得积分`
        : value.scene == 1004 || value.scene == 1018
        ? `完善基本资料获得积分`
        : value.scene == 1003 || value.scene == 1019
        ? `完成语音录制获得积分`
        : value.scene == 1008 || value.scene == 1020
        ? `完成实名认证获得积分`
        : value.scene == 15
        ? `邀请的好友${value.otherUserNickName}购买钻石奖励积分`
        : value.scene == 16
        ? `邀请的好友${value.otherUserNickName}收获礼物奖励积分`
        : value.scene == 17
        ? `邀请好友${value.otherUserNickName}注册成功奖励积分`
        : value.scene == 1026
        ? `点赞动态获得${value.amount}积分`
        : value.scene == 1027
        ? `评论动态获得${value.amount}积分`
        : value.scene == 1029
        ? `完善标签收益`
        : value.scene == 1030
        ? `完善感情观收益`
        : value.scene == 1031
        ? `完善兴趣爱好收益`
        : value.scene == 1028
        ? `完善关于我收益`
        : value.scene == 1034
        ? `发布征婚获得积分`
        : value.scene == 1035
        ? `发布征婚获得积分`
        : value.scene == 1036
        ? `真实头像认证获得积分`
        : value.scene == 1037
        ? `扔漂流瓶获得积分`
        : value.scene == 1038
        ? `捞漂流瓶获得积分`
        : value.scene == 1039
        ? `扔漂流瓶获得积分`
        : value.scene == 1040
        ? `捞漂流瓶获得积分`
        : value.scene == 19
        ? `完成聊天任务获得`
        : value.scene == 18
        ? `与${value.otherUserNickName}语音聊天${value.num}分钟获得`
        : value.scene == 1041 || value.scene == 1042
        ? `和${value.otherUserNickName}语音聊天成功获得积分`
        : value.scene == 1043 || value.scene == 1045 || value.scene == 1046
        ? `拨打语音通话成功奖励${value.amount}积分`
        : value.scene == 2001 || value.scene == 2002
        ? `完成语音房任务【语音房教程】奖励`
        : value.scene == 2003 || value.scene == 2004
        ? `完成语音房任务【首次创建房间】奖励`
        : value.scene == 2005 || value.scene == 2006
        ? `语音房任务【语音房上麦5分钟】奖励完成`
        : value.scene == 2007 || value.scene == 2008
        ? `语音房任务【语音房玩游戏3分钟】奖励`
        : value.scene == 2009 || value.scene == 2010
        ? `语音房任务【观看语音房直播10分钟】奖励`
        : value.scene == 2011
        ? `语音房任务【语音房送出礼物】奖励`
        : value.scene == 3001
        ? `直播获得${value.amount}积分礼物，额外获得积分 `
        : value.scene == 3002
        ? `直播上麦时长奖励`
        : value.scene == 3003
        ? `收获${value.otherUserNickName}赠送的${value.giftName}`
        : value.scene == 3004
        ? `完成直播礼物任务获得${value.amount}积分`
        : value.scene == 21
        ? `动态语音文件被下载分成获得${value.amount}积分`
        : value.scene == 1048
        ? `完成调查问卷获得积分`
        : value.scene == 1044
        ? `学习语音聊天技巧奖励${value.amount}积分`
        : value.scene == 3005
        ? `参与奖金瓜分活动获得${value.amount}积分`
        : ''
    }
  }

  get Scene() {
    return (value: any) => {
      console.log(value)
      return value.scene == 5
        ? `收获xx赠送的xx`
        : value.scene == 4 || value.scene == 8 || value.scene == 14
        ? `回复xx的打招呼消息获得积分`
        : value.scene == 1 || value.scene == 3 || value.scene == 7
        ? `回复xx的消息获得积分`
        : value.scene == 1009 || value.scene == 1021
        ? `签到获得x积分`
        : value.scene == 2
        ? `回复xx的平台牵线消息获得积分`
        : value.scene == 1010 || value.scene == 1022
        ? `观看激励视频获得积分`
        : value.scene == 1011 || value.scene == 1023
        ? `发布动态获得积分`
        : value.scene == 1024
        ? `使用今日缘分匹配获得积分`
        : value.scene == 1015
        ? `开通悬浮窗通知获得积分`
        : value.scene == 1016
        ? `开启地理位置获得积分`
        : value.scene == 1005 || value.scene == 1017
        ? `上传5张照片获得积分`
        : value.scene == 1004 || value.scene == 1018
        ? `完善基本资料获得积分`
        : value.scene == 1003 || value.scene == 1019
        ? `完成语音录制获得积分`
        : value.scene == 1008 || value.scene == 1020
        ? `完成实名认证获得积分`
        : value.scene == 15
        ? `邀请的好友xx购买钻石奖励积分`
        : value.scene == 16
        ? `邀请的好友xx收获礼物奖励积分`
        : value.scene == 17
        ? `邀请好友xx注册成功奖励积分`
        : value.scene == 1026
        ? `点赞动态获得xx积分`
        : value.scene == 1027
        ? `评论动态获得xx积分`
        : value.scene == 1029
        ? `完善标签收益`
        : value.scene == 1030
        ? `完善感情观收益`
        : value.scene == 1031
        ? `完善兴趣爱好收益`
        : value.scene == 1028
        ? `完善关于我收益`
        : value.scene == 1034
        ? `发布征婚获得积分`
        : value.scene == 1035
        ? `发布征婚获得积分`
        : value.scene == 1036
        ? `真实头像认证获得积分`
        : value.scene == 1037
        ? `扔漂流瓶获得积分`
        : value.scene == 1038
        ? `捞漂流瓶获得积分`
        : value.scene == 1039
        ? `扔漂流瓶获得积分`
        : value.scene == 1040
        ? `捞漂流瓶获得积分`
        : value.scene == 18
        ? `与xx语音聊天x分钟获得`
        : value.scene == 19
        ? `完成聊天任务获得`
        : value.scene == 1041 || value.scene == 1042
        ? `和xx语音聊天成功获得积分`
        : value.scene == 2001 || value.scene == 2002
        ? `完成语音房任务【语音房教程】奖励`
        : value.scene == 2003 || value.scene == 2004
        ? `完成语音房任务【首次创建房间】奖励`
        : value.scene == 2005 || value.scene == 2006
        ? `语音房任务【语音房上麦5分钟】奖励完成`
        : value.scene == 2007 || value.scene == 2008
        ? `语音房任务【语音房玩游戏3分钟】奖励`
        : value.scene == 2009 || value.scene == 2010
        ? `语音房任务【观看语音房直播10分钟】奖励`
        : value.scene == 2011
        ? `语音房任务【语音房送出礼物】奖励`
        : value.scene == 3001
        ? `直播获得xx积分礼物，额外获得积分`
        : value.scene == 3002
        ? `直播上麦时长奖励`
        : value.scene == 3003
        ? `收获xx赠送的xx`
        : value.scene == 3004
        ? `完成直播礼物任务获得xx积分`
        : value.scene == 21
        ? `动态语音文件被下载分成获得x积分`
        : value.scene == 1048
        ? `完成调查问卷获得积分`
        : value.scene == 1044
        ? `学习语音聊天技巧奖励x积分`
        : value.scene == 3005
        ? `参与奖金瓜分活动获得x积分`
        : ''
    }
  }
}
